import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

export default class TranscriptInfoBox extends React.Component {

  calculateWidth = () => {
    let width = 0;
    if( this.props.screenWidth < 1030 || this.props.screenWidth >= 1030 ) {
      width = 400;
    }
    if( this.props.screenWidth < 700 ) {
      width = 400;
    }
    if( this.props.screenWidth <= 400 ) {
      width = 390;
    }
    if( this.props.screenWidth < 360 ) {
      width = 320;
    }
    return width;
  }

  renderLoader = () => {
    return <h1>Loading</h1>
  }

  createMarkup = ( string ) => {

    // p tags in case we need them
    let formatted = '';
    if( string.charAt(0) !== '<' ) {
      string = string.replace(/\r\n|\r|\n/g,'<br>');
      formatted = '<p class="transcript-copy">' + string + '</p>';
    } else {
      formatted = string;
    }

    return {__html: formatted };
  }

  renderContent = () => {
    return <span dangerouslySetInnerHTML={this.createMarkup( this.props.payload )} />;
  }

  render() {

    let width = this.calculateWidth();

    return (
      <div className={"modal-content info-box"}>
        <div className={'modal-content-responsive-container'} style={{ width: width, height: this.props.screenHeight * .75}}>

          <Scrollbars style={{ width: width, height: this.props.screenHeight * .75 }}>

            <div className={"modal-scrollable-content"}>
              { ( this.props.payload === '' || this.props.payload === undefined ) ? this.renderLoader() : this.renderContent() }
            </div>

        </Scrollbars>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/TranscriptBox.js